import React from 'react';

// Utils
import { getTimeAgoLabel } from 'Shared/utils/DateTime.utils';

// Types
import { Member } from 'Shared/types/Member.type';

type Props = {
  member: Member;
};

const MemberLastSeenAt = ({ member }: Props) => {
  const isInvitePending = (!member.confirmedAt && member.confirmationSentAt) || !member.lastSeenAt;
  return <div>{isInvitePending ? <em>Invite Pending</em> : getTimeAgoLabel(member.lastSeenAt, false)}</div>;
};

export default MemberLastSeenAt;
